

































































































































































































































































































































































































































































































































































































































import Component, { mixins } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import ImgUploader from "@/components/common/ImgUploader.vue";
import { getStorageBoolean } from "@/types";
import VueRouter from "vue-router";
import { ShowSnackbar } from "@/store/modules/showSnackbar/types";
import { State } from "vuex-class";
import CellCharInput from "@/components/common/CellCharInput.vue";
import AlphaNumHalfKanaTextField from "@/components/settings/AlphaNumHalfKanaTextField.vue";
import { moji2Hankana, moji2HanAlphaNum, hankana2Upper } from "@/types";

//事業所設定情報
interface OfficeSetting {
  office_unique_id: number;
  com_inv_remarks: string;
  com_rece_remarks: string;
  is_print_inv_officename: boolean;
  print_inv_officename: string;
  created_at: string;
  updated_at: string;
  deleted_at: string;
}

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    ImgUploader,
    LoadingDialog,
    CellCharInput,
    AlphaNumHalfKanaTextField
  }
})
export default class Settings extends mixins(AxiosMixin) {
  @State("showsnackbar") snack!: ShowSnackbar;

  @Ref("imgUploader") private readonly imgUploader!: ImgUploader;

  get isSamePrint(): boolean {
    return !getStorageBoolean("isSamePrint", false);
  }
  set isSamePrint(value: boolean) {
    localStorage.setItem("isSamePrint", String(!value));
  }

  get isShahoRatioPrint(): boolean {
    return !getStorageBoolean("isShahoRatioPrint", false);
  }
  set isShahoRatioPrint(value: boolean) {
    localStorage.setItem("isShahoRatioPrint", String(!value));
  }

  get isNengoPrint(): boolean {
    return getStorageBoolean("isNengoPrint", false);
  }
  set isNengoPrint(value: boolean) {
    localStorage.setItem("isNengoPrint", String(value));
  }
  private isSwitchLoading = false;
  private isShow2ndBurden = false;
  private useMedInvMultiMonth = -1;
  private accountTransferCodeDiv = -1;
  private isUinvPrintNumber = false;
  private isUinvPrintOfficeSealFrame = false;
  private isUinvPrintOfficeSealInvoice = false;
  private isUinvPrintOfficeSealReceipt = false;
  private isUinvPrintTransferPaymentNone = false;
  private isUinvPrintTransferPaymentCollect = false;
  private isUinvPrintTransferPaymentTransfer = false;
  private isUinvPrintTransferPaymentWithdrawl = false;
  private isUinvPrintTransferReceipt = false;
  private useAnyCustomerNumberDiv = -1;
  private bankNo = "";
  private bankName = "";
  private branchNo = "";
  private branchName = "";
  private depositType = "";
  private accountNo = "";

  // 設定キー
  private readonly kIsShow2ndBurden = "MEDICAL_SPEC_2ND_BURDEN";
  private readonly kUseMedInvMultiMonth = "MEDICAL_INV_MULTI_MONTH";
  private readonly kAccountTransferCodeDiv = "ACCOUNT_TRANSFER_CODE_DIV";
  private readonly kUinvPrintNumber = "UINV_PRINT_NUMBER";
  private readonly kUinvPrintOfficeSealFrame = "UINV_PRINT_OFFICE_SEAL_FRAME";
  private readonly kUinvPrintOfficeSealInvoice =
    "UINV_PRINT_OFFICE_SEAL_INVOICE";
  private readonly kUinvPrintOfficeSealReceipt =
    "UINV_PRINT_OFFICE_SEAL_RECEIPT";
  private readonly kUinvPrintTransferPaymentNone =
    "UINV_PRINT_TRANSFER_PAYMENT_NONE";
  private readonly kUinvPrintTransferPaymentCollect =
    "UINV_PRINT_TRANSFER_PAYMENT_COLLECT";
  private readonly kUinvPrintTransferPaymentTransfer =
    "UINV_PRINT_TRANSFER_PAYMENT_TRANSFER";
  private readonly kUinvPrintTransferPaymentWithdrawl =
    "UINV_PRINT_TRANSFER_PAYMENT_WITHDRAWAL";
  private readonly kUinvPrintTransferReceipt = "UINV_PRINT_TRANSFER_RECEIPT";
  private readonly kUseAnyCustomerNumberDiv = "USE_ANY_CUSTOMER_NUMBER_DIV";
  private readonly kBankNumber = "BANK_NUMBER";
  private readonly kBankName = "BANK_NAME";
  private readonly kBranchNumber = "BRANCH_NUMBER";
  private readonly kBranchName = "BRANCH_NAME";
  private readonly kDepositType = "DEPOSIT_TYPE";
  private readonly kAccountNumber = "ACCOUNT_NUMBER";

  private isEdit = false;
  private setting: OfficeSetting = {
    office_unique_id: 0,
    com_inv_remarks: "",
    com_rece_remarks: "",
    is_print_inv_officename: false,
    print_inv_officename: "",
    created_at: "",
    updated_at: "",
    deleted_at: ""
  };
  // 社印データ
  private officeSealData = "";

  mounted() {
    this.update();
  }

  //----------------------------------------------
  // 画面更新
  //----------------------------------------------
  private update() {
    this.postJsonCheck(window.base_url + "/api/office/setting/get", {}, res => {
      this.setting = res.data.setting;
      const map = res.data.map;
      this.isShow2ndBurden = map[this.kIsShow2ndBurden] == "1";
      this.useMedInvMultiMonth = Number(map[this.kUseMedInvMultiMonth]);
      this.accountTransferCodeDiv = Number(map[this.kAccountTransferCodeDiv]);
      this.isUinvPrintNumber = map[this.kUinvPrintNumber] == "1";
      this.isUinvPrintOfficeSealFrame =
        map[this.kUinvPrintOfficeSealFrame] == "1";
      this.isUinvPrintOfficeSealInvoice =
        map[this.kUinvPrintOfficeSealInvoice] == "1";
      this.isUinvPrintOfficeSealReceipt =
        map[this.kUinvPrintOfficeSealReceipt] == "1";
      this.isUinvPrintTransferPaymentNone =
        map[this.kUinvPrintTransferPaymentNone] == "1";
      this.isUinvPrintTransferPaymentCollect =
        map[this.kUinvPrintTransferPaymentCollect] == "1";
      this.isUinvPrintTransferPaymentTransfer =
        map[this.kUinvPrintTransferPaymentTransfer] == "1";
      this.isUinvPrintTransferPaymentWithdrawl =
        map[this.kUinvPrintTransferPaymentWithdrawl] == "1";
      this.isUinvPrintTransferReceipt =
        map[this.kUinvPrintTransferReceipt] == "1";
      this.useAnyCustomerNumberDiv = Number(map[this.kUseAnyCustomerNumberDiv]);
      this.bankNo = map[this.kBankNumber];
      this.bankName = map[this.kBankName];
      this.branchNo = map[this.kBranchNumber];
      this.branchName = map[this.kBranchName];
      this.depositType = map[this.kDepositType];
      this.accountNo = map[this.kAccountNumber];

      this.officeSealDownload();
    });
  }

  //----------------------------------------------
  // 非同期スイッチリクエスト制御
  //----------------------------------------------
  private clickSwitch(key: string, value: boolean) {
    this.isSwitchLoading = true;
    const map = { [key]: value ? "0" : "1" };
    const param = { map: map };
    this.postJsonCheckFailWithNoLoading(
      window.base_url + "/api/office/setting/dictionary/save",
      param,
      res => {
        // 成功
        this.isSwitchLoading = false;
        const map = res.data.map;
        this.setPropFromKeyForSwitch(key, map[key] == "1");
      },
      () => {
        // 失敗(もとに戻す)
        this.isSwitchLoading = false;
        this.setPropFromKeyForSwitch(key, value);
      }
    );
    this.setPropFromKeyForSwitch(key, !value);
  }

  //----------------------------------------------
  // スイッチに値を設定
  //----------------------------------------------
  private setPropFromKeyForSwitch(key: string, value: boolean) {
    switch (key) {
      case this.kIsShow2ndBurden:
        this.isShow2ndBurden = value;
        break;
      case this.kUinvPrintNumber:
        this.isUinvPrintNumber = value;
        break;
      case this.kUinvPrintOfficeSealFrame:
        this.isUinvPrintOfficeSealFrame = value;
        break;
      case this.kUinvPrintOfficeSealInvoice:
        this.isUinvPrintOfficeSealInvoice = value;
        break;
      case this.kUinvPrintOfficeSealReceipt:
        this.isUinvPrintOfficeSealReceipt = value;
        break;
      case this.kUinvPrintTransferPaymentNone:
        this.isUinvPrintTransferPaymentNone = value;
        break;
      case this.kUinvPrintTransferPaymentCollect:
        this.isUinvPrintTransferPaymentCollect = value;
        break;
      case this.kUinvPrintTransferPaymentTransfer:
        this.isUinvPrintTransferPaymentTransfer = value;
        break;
      case this.kUinvPrintTransferPaymentWithdrawl:
        this.isUinvPrintTransferPaymentWithdrawl = value;
        break;
      case this.kUinvPrintTransferReceipt:
        this.isUinvPrintTransferReceipt = value;
        break;
    }
  }

  //----------------------------------------------
  //画面遷移
  //----------------------------------------------
  private beforeRouteLeave(to: VueRouter, from: VueRouter, next: Function) {
    if (this.isEdit) {
      if (!confirm("入力した情報が保存されていません。よろしいですか？")) {
        // this.$nextTick(() => {
        //  this.navigationManage();
        // });
        next(false);
        return;
      }
    }
    next();
  }

  //----------------------------------------------
  // 保存ボタンクリックイベント
  //----------------------------------------------
  private save() {
    // 取引銀行名と取引支店名は15文字まで半角スペースで埋める
    this.bankName = this.spacePaddingEnd(this.bankName, 15);
    this.branchName = this.spacePaddingEnd(this.branchName, 15);
    const map = {
      [this.kUseMedInvMultiMonth]: this.useMedInvMultiMonth.toString(),
      [this.kAccountTransferCodeDiv]: this.accountTransferCodeDiv.toString(),
      [this.kUseAnyCustomerNumberDiv]: this.useAnyCustomerNumberDiv.toString(),
      [this.kBankNumber]: this.bankNo,
      [this.kBankName]: this.bankName,
      [this.kBranchNumber]: this.branchNo,
      [this.kBranchName]: this.branchName,
      [this.kDepositType]: this.depositType,
      [this.kAccountNumber]: this.accountNo
    };
    const param = {
      setting: this.setting,
      map: map
    };

    this.postJsonCheck(
      window.base_url + "/api/office/setting/save",
      param,
      res => {
        this.setting = res.data.setting;
        this.isEdit = false;
        this.snack.message = "保存しました。";
        this.snack.showSnackbar = true;
      }
    );
  }

  //----------------------------------------------
  // 社印画像ダウンロード
  //----------------------------------------------
  private officeSealDownload() {
    this.postJsonBlobResWithNotFound(
      window.base_url + "/api/office/officeseal/download",
      {},
      res => {
        const blob = new Blob([res.data], { type: "application/octet-binary" });
        this.officeSealData = URL.createObjectURL(blob);
      },
      err => {
        this.officeSealData = ""; // 404存在しない
      }
    );
  }

  //----------------------------------------------
  // 社印画像削除
  //----------------------------------------------
  private officeSealDelete() {
    if (!confirm("登録されているデジタル社印を削除します。\nよろしいですか?")) {
      return;
    }
    this.postJsonBlobResWithNotFound(
      window.base_url + "/api/office/officeseal/delete",
      {},
      res => {
        this.officeSealData = ""; // 削除成功
      },
      err => {
        this.officeSealData = ""; // 404存在しない
      }
    );
  }

  //----------------------------------------------
  // 社印画像登録ダイアログオープン
  //----------------------------------------------
  private openImgUploader() {
    const exists = this.officeSealData != "";
    this.imgUploader.open(exists);
  }

  //----------------------------------------------
  // 社印画像登録ダイアログクローズ
  //----------------------------------------------
  private closeImgUploader(uploaded: boolean) {
    if (uploaded) {
      this.officeSealDownload();
    }
  }

  private spacePaddingEnd(str: string, length: number): string {
    return str.padEnd(length);
  }
}
